import { localisedValue } from "utils"

const buildIdLocCodeById = response =>
  (response ?? []).reduce((acc, e) => {
    if (e?.id != null && e?.locCode != null) {
      acc[e.id] = e.locCode
      acc[String(e.id)] = e.locCode
    }
    return acc
  }, {})

const countryTransformer = (response, arg) => {
  const nationalityFlag = typeof arg === "boolean" ? arg : arg?.nationalityFlag
  const includeIdLocCodeById = typeof arg === "object" && arg?.includeIdLocCodeById

  if (!response) {
    if (nationalityFlag) {
      return includeIdLocCodeById ? { countries: [], nationalities: [], idLocCodeById: {} } : { countries: [], nationalities: [] }
    }
    return includeIdLocCodeById ? { countries: [], idLocCodeById: {} } : []
  }

  const idLocCodeById = includeIdLocCodeById ? buildIdLocCodeById(response) : null

  const countries = response.map(e => ({
    ...e,
    key: e?.id,
    label: localisedValue({ object: e, key: "name" }),
    value: e?.id?.toString(),
  }))

  if (nationalityFlag) {
    const nationalities = response.map(e => ({
      ...e,
      label: localisedValue({ object: e, key: "nationalityTitle" }),
      value: e?.id,
    }))

    return {
      countries,
      nationalities,
      ...(includeIdLocCodeById ? { idLocCodeById } : {}),
    }
  }

  if (includeIdLocCodeById) {
    return { countries, idLocCodeById }
  }

  return countries
}

export default countryTransformer
